/* Depila Sem Dor · página unissex */
(function(){
  var $=function(s,r){return (r||document).querySelector(s)},$$=function(s,r){return [].slice.call((r||document).querySelectorAll(s))};

  /* galeria */
  var track=$('.dsu #track'),nav=$('.dsu #gnav');
  if(track&&nav){
    var slides=track.children,dots=[];
    for(var i=0;i<slides.length;i++){(function(k){var b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Imagem '+(k+1));b.onclick=function(){go(k)};nav.appendChild(b);dots.push(b)})(i)}
    var cur=function(){return Math.round(track.scrollLeft/track.clientWidth)};
    var go=function(k){k=Math.max(0,Math.min(slides.length-1,k));track.scrollTo({left:k*track.clientWidth,behavior:'smooth'})};
    var mark=function(){var c=cur();dots.forEach(function(d,j){d.setAttribute('aria-current',j===c?'true':'false')})};
    track.addEventListener('scroll',function(){window.requestAnimationFrame(mark)});mark();
    $('.dsu #gprev').onclick=function(){go(cur()-1)};
    $('.dsu #gnext').onclick=function(){go(cur()+1)};

    /* miniaturas (aparecem só no desktop, pelo CSS) */
    var th=document.createElement('div');th.className='thumbs';th.setAttribute('aria-label','Miniaturas da galeria');
    [].forEach.call(slides,function(sl,k){var b=document.createElement('button');b.type='button';b.setAttribute('aria-label','Imagem '+(k+1));var m=sl.querySelector('img,video');if(m){var c;if(m.tagName==='VIDEO'&&m.poster){c=document.createElement('img');c.src=m.poster;c.alt=''}else{c=m.cloneNode(false);c.removeAttribute('fetchpriority')}c.setAttribute('loading','lazy');b.appendChild(c)}b.onclick=function(){go(k)};th.appendChild(b)});
    nav.after(th);
    var thb=th.querySelectorAll('button');
    track.addEventListener('scroll',function(){var c=cur();[].forEach.call(thb,function(b,j){b.setAttribute('aria-current',j===c?'true':'false')});var tb=thb[c];if(tb){var l=tb.offsetLeft-th.offsetLeft,w=th.clientWidth;if(l<th.scrollLeft||l+tb.offsetWidth>th.scrollLeft+w)th.scrollTo({left:l-w/2+tb.offsetWidth/2,behavior:'smooth'})}});
    if(thb[0])thb[0].setAttribute('aria-current','true');
    var mq=window.matchMedia('(min-width: 1024px)'),re=function(){setTimeout(function(){go(cur())},50)};
    mq.addEventListener?mq.addEventListener('change',re):mq.addListener(re);
  }

  /* antes e depois: setas */
  var b2=$('.dsu #ba2');
  if(b2)$$('.dsu .ba2nav').forEach(function(btn){btn.addEventListener('click',function(){var c=b2.querySelector('.ba2c');var step=c?c.getBoundingClientRect().width+12:300;b2.scrollBy({left:btn.classList.contains('next')?step:-step,behavior:'smooth'})})});

  /* oferta: kit (2 unidades) ou 1 unidade */
  var plans={kit:{qty:2,cta:'GARANTIR MEU KIT AGORA',name:'Kit 500g',price:'R$59,90 cada',btn:'QUERO MEU KIT'},one:{qty:1,cta:'QUERO MEU DEPILA SEM DOR',name:'1 Depila Sem Dor',price:'R$79,90',btn:'QUERO O MEU'}};
  var cards=$$('.dsu .offer .card'),qty=$('#ds-qty'),setTxt=function(id,t){var e=document.getElementById(id);if(e)e.textContent=t};
  cards.forEach(function(c){c.addEventListener('click',function(){
    cards.forEach(function(x){x.setAttribute('aria-checked','false')});c.setAttribute('aria-checked','true');
    // textos e quantidade vêm do próprio card (data-*); sem eles, vale o padrão do Depila
    var d=c.dataset,base=plans[d.plan]||{};
    var p={qty:d.qty?+d.qty:base.qty,cta:d.cta||base.cta,name:d.stName||base.name,price:d.stPrice||base.price,btn:d.stBtn||base.btn};
    if(!p.qty)return;
    if(qty)qty.value=p.qty;
    if(form)form.dataset.items=d.items||'';
    setTxt('cta-main',p.cta);setTxt('st-name',p.name);setTxt('st-price',p.price);setTxt('st-btn',p.btn);
    var si=document.getElementById('st-img'),ci=c.querySelector('img');if(si&&ci)si.src=ci.src;
  })});
  var form=document.getElementById('ds-form');
  var kitSel=document.querySelector('.dsu .offer .card[aria-checked="true"]');
  if(form&&kitSel)form.dataset.items=kitSel.dataset.items||'';
  /* kit com produtos diferentes: data-items="variante:qtd,..." no card */
  function itemsOf(){
    var raw=form&&form.dataset.items;if(!raw)return null;
    var list=raw.split(',').map(function(x){var a=x.split(':');return {id:+a[0],quantity:+(a[1]||1)}}).filter(function(i){return i.id&&i.quantity>0});
    return list.length?list:null;
  }
  /* adiciona sem sair da página e abre o carrinho lateral do tema (mesmo evento que o botão padrão usa);
     sem gaveta ou com erro, segue o envio normal para /cart */
  /* depois de adicionar, o app de brinde re-renderiza o carrinho e pode fechar a gaveta;
     por 5s ela é reaberta se fechar sem o cliente ter tocado nela */
  function keepDrawerOpen(){
    var cd=document.querySelector('cart-drawer-component');if(!cd||typeof cd.showDialog!=='function')return;
    var touched=false,mark=function(e){if(e.type!=='keydown'||e.key==='Escape')touched=true};
    cd.addEventListener('pointerdown',mark,true);document.addEventListener('keydown',mark,true);
    var end=Date.now()+5000,iv=setInterval(function(){
      var d=cd.querySelector('dialog');
      if(touched||Date.now()>end){clearInterval(iv);cd.removeEventListener('pointerdown',mark,true);document.removeEventListener('keydown',mark,true);return}
      if(d&&!d.open&&!d.classList.contains('dialog-closing'))cd.showDialog();
    },250);
  }
  if(form)form.addEventListener('submit',function(e){
    var b=document.getElementById('cta-main'),busy=function(on){if(b){b.disabled=on;b.style.opacity=on?'.75':''}};
    var items=itemsOf(),drawer=!!document.querySelector('cart-drawer-component');
    var root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    /* sem gaveta, o kit vai para a página do carrinho (o envio normal do formulário levaria só 1 produto) */
    var fallback=function(){if(items)window.location.href=root+'cart';else form.submit()};
    if(!window.fetch||(!drawer&&!items)){busy(true);return}
    e.preventDefault();busy(true);
    var ids=$$('cart-items-component').map(function(c){return c.dataset.sectionId}).filter(Boolean);
    var body=items?{items:items}:{id:+form.querySelector('input[name="id"]').value,quantity:+(qty?qty.value:1)};
    var count=items?items.reduce(function(s,i){return s+i.quantity},0):body.quantity;
    if(ids.length&&drawer)body.sections=ids.join(',');
    fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify(body)})
      .then(function(r){return r.json()})
      .then(function(res){
        /* a Shopify recusa o kit inteiro se faltar estoque de um item: avisa em vez de levar a um carrinho vazio */
        if(res.status){busy(false);if(items)window.alert(res.description||'Não foi possível adicionar o kit. Tente novamente.');else form.submit();return}
        if(!drawer){window.location.href=root+'cart';return}
        var ev=new Event('cart:update',{bubbles:true});
        ev.detail={resource:undefined,sourceId:String(items?items[0].id:body.id),data:{source:'product-form-component',itemCount:count,sections:res.sections}};
        form.dispatchEvent(ev);busy(false);keepDrawerOpen();
      })
      .catch(function(){busy(false);fallback()});
  });
  /* botões secundários levam até a escolha do kit */
  $$('.dsu .js-cta').forEach(function(b){b.addEventListener('click',function(){var k=document.getElementById('opt-kit');if(k)k.scrollIntoView({behavior:'smooth',block:'center'})})});

  /* depoimentos por tópico */
  var pills=$$('.dsu .tp'),pans=$$('.dsu .tpanel'),vr=$('.dsu #vrow2');
  pills.forEach(function(b){b.addEventListener('click',function(){
    var t=b.dataset.t;
    pills.forEach(function(x){x.setAttribute('aria-selected',x===b?'true':'false')});
    pans.forEach(function(pn){pn.hidden=pn.dataset.t!==t});
    if(!vr)return;
    var first=null;$$('.vcard',vr).forEach(function(v){var on=v.dataset.t===t;v.classList.toggle('hl',on);if(on&&!first)first=v});
    if(first)vr.scrollTo({left:first.offsetLeft-vr.offsetLeft,behavior:'smooth'});
  })});

  /* zoom das ilustrações */
  $$('.dsu .zoom').forEach(function(z){var im=z.parentNode.querySelector('img.ilus');if(!im)return;z.style.backgroundImage='url('+(im.currentSrc||im.src)+')';z.style.backgroundPosition=(z.dataset.fx*100)+'% '+(z.dataset.fy*100)+'%'});

  /* vídeos dos clientes: abrem ampliados, com som; X grande, toque no fundo ou Esc fecham */
  var vm=document.getElementById('vmodal'),vv=document.getElementById('vm-video'),vx=document.getElementById('vm-close');
  if(vm&&vv&&vx){
    var opener=null;
    var closeVm=function(){if(vm.hidden)return;vv.pause();vv.removeAttribute('src');vv.load();vm.hidden=true;document.documentElement.classList.remove('ds-vm-open');if(opener)opener.focus({preventScroll:true})};
    $$('.dsu .vthumb').forEach(function(b){b.addEventListener('click',function(){
      var im=b.querySelector('img');if(!im||!im.dataset.video)return;
      opener=b;vv.poster=im.currentSrc||im.src;vv.src=im.dataset.video;
      vm.hidden=false;document.documentElement.classList.add('ds-vm-open');vx.focus({preventScroll:true});
      var p=vv.play();if(p&&p.catch)p.catch(function(){});
    })});
    vx.addEventListener('click',closeVm);
    vm.addEventListener('click',function(e){if(e.target===vm||e.target.classList.contains('box'))closeVm()});
    document.addEventListener('keydown',function(e){if(e.key==='Escape')closeVm()});
  }

  /* mensagem de envio: até 14h (seg a sex) sai hoje; depois, prazo da próxima hora; sex 14h+ e fim de semana, segunda */
  var MESES=['janeiro','fevereiro','março','abril','maio','junho','julho','agosto','setembro','outubro','novembro','dezembro'];
  function spNow(){
    var parts=new Intl.DateTimeFormat('en-CA',{timeZone:'America/Sao_Paulo',year:'numeric',month:'2-digit',day:'2-digit',hour:'2-digit',minute:'2-digit',hourCycle:'h23'}).formatToParts(new Date());
    var o={};parts.forEach(function(p){o[p.type]=p.value});
    return new Date(+o.year,+o.month-1,+o.day,+o.hour,+o.minute);
  }
  function msg(d){
    var h=d.getHours(),m=d.getMinutes(),dow=d.getDay(),weekday=dow>=1&&dow<=5;
    if(weekday&&h<14)return 'Comprando até <b>14h</b>, enviamos <b>hoje</b>.';
    var lim=h+1+(m>0?1:0),limTxt=(h>=23||lim>=24)?'23h59':lim+'h';
    var ship=new Date(d.getFullYear(),d.getMonth(),d.getDate()),seg=false;
    if(dow===5||dow===6||dow===0){var add=(8-dow)%7||7;ship.setDate(ship.getDate()+add);seg=true}
    else ship.setDate(ship.getDate()+1);
    var data=ship.getDate()+' de '+MESES[ship.getMonth()];
    return 'Comprando até <b>'+limTxt+'</b>, enviado <b>'+(seg?'segunda-feira, ':'')+data+'</b>.';
  }
  function render(){var t=msg(spNow());$$('.dsu .ship-msg').forEach(function(s){s.innerHTML=t})}
  render();setInterval(render,60000);
})();
